"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require("babel-runtime/helpers/get");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = autoclass;

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var done = {};

function autoclass(componentClass) {
  var packageName = void 0;

  if (module && module.parents && module.parents.length) {
    var parent = module.parents[module.parents.length - 1];
    var parentPath = parent;
    var parentPaths = parentPath.split("/");

    var _modulesIndex = void 0;
    parentPaths.forEach(function (path, index) {
      if (path.indexOf("_modules") > -1) _modulesIndex = index;
    });
    packageName = _modulesIndex > -1 ? parentPaths[_modulesIndex + 1] : parentPaths[parentPaths.length - 1].replace(".js", "");
  }

  var componentName = componentClass.displayName || componentClass.name;
  var prefix = packageName && !done[packageName] ? packageName + " " + componentName : componentName;

  if (packageName) {
    done[packageName] = true;
  }

  var DecoratedComponent = function (_componentClass) {
    (0, _inherits3.default)(DecoratedComponent, _componentClass);

    function DecoratedComponent() {
      (0, _classCallCheck3.default)(this, DecoratedComponent);
      return (0, _possibleConstructorReturn3.default)(this, (DecoratedComponent.__proto__ || (0, _getPrototypeOf2.default)(DecoratedComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(DecoratedComponent, [{
      key: "render",
      value: function render() {
        var element = (0, _get3.default)(DecoratedComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(DecoratedComponent.prototype), "render", this).call(this);
        if (!element) return element;
        var changes = {
          className: ((prefix || '') + " " + (element.type && element.type.name || '') + " " + (element.props.className || '')).trim()
        };
        return (0, _keys2.default)(changes).length === 0 ? element : (0, _react.cloneElement)(element, changes, element.props.children);
      }
    }]);
    return DecoratedComponent;
  }(componentClass);

  // for some reason losing statics
  (0, _keys2.default)(componentClass).forEach(function (k) {
    return !DecoratedComponent.hasOwnProperty(k) && (DecoratedComponent[k] = componentClass[k]);
  });

  // Add `className` propType, if none exists
  DecoratedComponent.propTypes = (0, _extends3.default)({ className: _react.PropTypes.string }, componentClass.propTypes);

  return DecoratedComponent;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(done, "done", "src/core_modules/autoclass-decorator/index.js");

  __REACT_HOT_LOADER__.register(autoclass, "autoclass", "src/core_modules/autoclass-decorator/index.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js
// module chunks = 0